var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('h2',{staticClass:"report-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"chart-container"},[_c('canvas',{ref:"productionChart",attrs:{"height":"360"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }